import type {ExtendedRepository} from '../../../../api/common-contracts'
import type {FieldAggregate} from '../../../../hooks/use-aggregation-settings'
import {RepositoryIcon} from '../../../fields/repository/repository-icon'
import {AggregateLabels} from '../../aggregate-labels'
import {SanitizedGroupHeaderText} from '../sanitized-group-header-text'
import styles from './repository-group-header-label.module.css'

type Props = {
  repository: ExtendedRepository
  rowCount: number
  hideItemsCount: boolean
  aggregates: Array<FieldAggregate>
  titleClassName?: string
}

export function RepositoryGroupHeaderLabel({repository, rowCount, aggregates, hideItemsCount, titleClassName}: Props) {
  return (
    <>
      <RepositoryIcon repository={repository} />
      <SanitizedGroupHeaderText titleHtml={repository.nameWithOwner} className={titleClassName} />
      <AggregateLabels
        itemsCount={rowCount}
        aggregates={aggregates}
        hideItemsCount={hideItemsCount}
        counterClassName={styles.AggregateLabels}
      />
    </>
  )
}

try{ RepositoryGroupHeaderLabel.displayName ||= 'RepositoryGroupHeaderLabel' } catch {}